"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getOMRWindowStatus = void 0;
var date_fns_1 = require("date-fns");
var getOMRWindowStatus = function (supplyStart) {
    var toDaysAfterSSD = 5;
    var currentDate = (0, date_fns_1.startOfToday)();
    var windowStart = (0, date_fns_1.startOfDay)(supplyStart);
    var windowEnd = (0, date_fns_1.addDays)((0, date_fns_1.startOfDay)(supplyStart), toDaysAfterSSD);
    var isBeforeWindow = (0, date_fns_1.isBefore)(currentDate, windowStart);
    var isDuringWindow = (0, date_fns_1.isWithinInterval)(currentDate, {
        start: windowStart,
        end: windowEnd,
    });
    return {
        startDate: windowStart.toISOString(),
        endDate: windowEnd.toISOString(),
        isBeforeWindow: isBeforeWindow,
        isDuringWindow: isDuringWindow,
        isAfterWindow: !isBeforeWindow && !isDuringWindow,
    };
};
exports.getOMRWindowStatus = getOMRWindowStatus;
